import Vue from 'vue';

new Vue({
    el: '#register-form',

    data: {
        first_name: null,
        last_name: null,
        email: null,
        phone: null,
        company_name: null,
        trading_address: null,
        city: null,
        postcode: null,
        country: null,
        existing_customer: null,
        pet_shop_license: null,
        company_website: null,
        account_code: null,
        password: null,
        password_confirmation: null,
    },

    methods: {
        isCompletedForm: function () {
            return this.isFilledDefaultFields() && (this.isExistingCustomer() || this.hasNoPetLicense());
        },

        isFilledDefaultFields: function () {
            return !!(this.first_name && this.last_name && this.email && this.phone && this.company_name && this.trading_address && this.city && this.postcode && this.country && this.password && this.password_confirmation);
        },

        isExistingCustomer: function () {
            return !!(this.existing_customer && this.account_code);
        },

        hasNoPetLicense: function () {
            return !!this.pet_shop_license;
        },

        checkForm(event) {
            if (this.pet_shop_license == 1 && jQuery('.license-photo .upload-files-container').children().length === 0) {
                swal('Oops!', 'Please upload a copy of your license.', 'error')
                event.preventDefault();
            }

            if (this.company_website == 0 && jQuery('.business-photos .upload-files-container').children().length === 0) {
                swal('Oops!', 'Please provide us with pictures of your business premises / facility.', 'error')
                event.preventDefault();
            }
        },

        checkLicense: function () {
            if (this.pet_shop_license == 0) {
                swal('Oops!', 'In order to setup account you are required to have a valid pet shop license.', 'error')
            }
        }
    }
});


// WEBPACK FOOTER //
// ./plugins/tradedress/user/assets/js/registration.js